export const buildImageUrl = (baseUrl: string, params: Record<string, string | number>): string => {
    if (!baseUrl) {
        return '';
    }

    let url: URL;
    try {
        url = new URL(baseUrl);
    } catch {
        return '';
    }

    url.searchParams.delete('w');
    url.searchParams.delete('h');
    url.searchParams.delete('auto');

    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, String(value));
    });

    return url.toString();
};
